import ReactDOM from 'react-dom';
import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import withMobileDialog from '@material-ui/core/withMobileDialog';

import './Modal.scss';
import Each from 'lodash/each';
declare var jQuery: any;
//declare var jquery: any;
//declare var $: JQueryStatic;

//import $ from 'jquery';
//window.jQuery = $;
//window.$ = $;

class Modal extends Component {
  
  constructor(props) {
    console.log('klejlskejse');
    super(props);
    this.state = {
      open: false,
      busy: false,
      complete: false,
      ready: false
    };
    let triggers = this.props.data.trigger.split(',');
    let $this = this;
    console.log('triggers', triggers);
    Each(triggers, function(item, key) {
      let watcherDom = item.split(' ');
      if(watcherDom.length == 2) {
        jQuery(watcherDom[0]).on( "click", watcherDom[1], () => {
          $this.toggle();
          return false;
        });

      } else {
        jQuery(watcherDom[0]).click(() => {
          $this.toggle()
        });
      }
      
    });
    if(this.props.data.continueBtnText === undefined) {
      this.props.data.continueBtnText = "OK";
    }
  }

  toggle = () => {
    if(this.setState.open) {
      jQuery('#'+this.props.data.scriptContentTargetId).empty();
    } else {
      if(this.props.data.scriptContentTargetId !== undefined && this.props.data.scriptContent !== undefined) { 
        this.setState({ open: !this.setState.open });
        jQuery.getScript( this.props.data.scriptContent+'&div='+this.props.data.scriptContentTargetId, (data, textStatus, jqxhr ) => {
          this.setState({ ready: true });
        });
      } else {
        this.setState({ open: !this.setState.open, ready: true });
      }
    }
  }

  handleClickOpen = () => {
    this.setState({ open: true });
  }

  handleClose = () => {
    this.setState({ open: false,
      busy: false,
      complete: false,
      ready: false });
    clearInterval(this.theWatcher);
  }

  handleScriptSubmit = () => {
    jQuery('#'+this.props.data.scriptContentTargetId).find('button.default').click();
    //start timer 
    this.theWatcher = setInterval(() => {
      if(!jQuery('#'+this.props.data.scriptContentTargetId).find('button.default').length) {
        this.setState({ complete: true });
      }
    },1000)
  }

  displayTitle = () => {
    if(this.props.data.title) {
       return (<DialogTitle>{this.props.data.title}</DialogTitle>); 
    } else {
      return null; 
    }
    
  }

  displayButtons = () => {
    if(!this.state.ready) {
      return null;
    }
    if(!this.state.complete ) { 
      if(this.props.data.scriptContent) {
        return (<DialogActions><Button onClick={this.handleClose} color="primary">
            Cancel
          </Button>
          <Button onClick={this.handleScriptSubmit} color="primary">
            {this.props.data.continueBtnText} 
          </Button> </DialogActions>);
      } else {
        return (<DialogActions><Button onClick={this.handleClose} color="primary">
            Cancel
          </Button>
          <Button onClick={this.handleClose} color="primary">
            {this.props.data.continueBtnText} 
          </Button> </DialogActions>);
      }
    } else {
      return (<div class="center"><Button onClick={this.handleClose} color="primary">
            OK
          </Button></div>);
    }
  }

  renderContent() {
    if(this.props.data.scriptContentTargetId !== undefined && this.props.data.scriptContent !== undefined) { 
      return (<div id={this.props.data.scriptContentTargetId} className={'complete_'+this.state.complete}><div className="lds-facebook"><div></div><div></div><div></div></div></div>
            );
    } else {
      return (<div>{this.props.data.content}</div>)
    }
  }

  render() {
    const { fullScreen } = this.props;
    return (
      <div>
        <Dialog
          className="njit-modal-component"
          fullScreen={fullScreen}
          open={this.state.open}
          onClose={this.handleClose}
          aria-labelledby="form-dialog-title"
        >
          {this.displayTitle()}
          <DialogContent>
            {this.renderContent()}
          </DialogContent>
            {this.displayButtons()}
        </Dialog>
       </div>
    );
  }
}

export default withMobileDialog()(Modal);



// WEBPACK FOOTER //
// ./src/Modal/Modal.js